import type { PaginatedResponse } from '../types/common';
import type {
  IntakeDecisionRequest,
  IntakeDecisionResponse,
  IntakeRequest,
  IntakeRequestFilter,
  IntakeRequestListItem,
  IntakeSubmissionResponse,
  SubmitIntakeRequest,
} from '../types/intakeRequest';
import { request } from './apiClient';

export function submitIntakeRequest(intakeRequest: SubmitIntakeRequest): Promise<IntakeSubmissionResponse> {
  return request<IntakeSubmissionResponse>('/api/intake-requests', {
    method: 'POST',
    body: JSON.stringify(intakeRequest),
  });
}

export function getIntakeRequests(
  status: IntakeRequestFilter,
): Promise<PaginatedResponse<IntakeRequestListItem>> {
  const query = status !== 'ALL' ? `?status=${encodeURIComponent(status)}` : '';
  return request<PaginatedResponse<IntakeRequestListItem>>(`/api/admin/intake-requests${query}`);
}

export function getIntakeRequest(requestId: string): Promise<IntakeRequest> {
  return request<IntakeRequest>(`/api/admin/intake-requests/${encodeURIComponent(requestId)}`);
}

export function approveIntakeRequest(
  requestId: string,
  decision: IntakeDecisionRequest,
): Promise<IntakeDecisionResponse> {
  return request<IntakeDecisionResponse>(`/api/admin/intake-requests/${encodeURIComponent(requestId)}/approve`, {
    method: 'POST',
    body: JSON.stringify(decision),
  });
}

export function denyIntakeRequest(
  requestId: string,
  decision: IntakeDecisionRequest,
): Promise<IntakeDecisionResponse> {
  return request<IntakeDecisionResponse>(`/api/admin/intake-requests/${encodeURIComponent(requestId)}/deny`, {
    method: 'POST',
    body: JSON.stringify(decision),
  });
}
